import type * as React from "react";
import instance from "~/utils/i18n";
import { type ReactNode } from "react";
import ProductPreferredIndicator from "~/features/productDetails/components/ProductPreferredIndicator";
import { Box, Stack, Typography } from "~/common/mui";
import FilePencilIcon from "~/common/mui/icons/FilePencil";

interface ProductTraitProps {
  className?: string;
  icon: ReactNode;
  children?: ReactNode;
}

type ProductTraitType = React.FC<ProductTraitProps>;

const ProductTrait: ProductTraitType = (props) => {
  const { className, icon, children } = props;

  return (
    <Stack className={className} direction="row" alignItems="center">
      <Box sx={{ mr: 1, color: "text.primary" }}>{icon}</Box>
      <Typography variant="bodyMedium" sx={{ color: "text.primary" }}>{children}</Typography>
    </Stack>
  );
};

interface PredefinedTraitProps {
  className?: string;
}

const PreferredProduct = (props: PredefinedTraitProps) => {
  return (
    <Stack className={props.className} direction="row" alignItems="center">
      <Box sx={{ mr: 1 }}><ProductPreferredIndicator /></Box>
      <Typography variant="bodyMedium" sx={{ color: "text.primary" }}>{instance.t("product.isPreferred")}</Typography>
    </Stack>
  );
};

const ContractProduct = (props: PredefinedTraitProps) => (
  <ProductTrait {...props} icon={<FilePencilIcon  />}>
    {instance.t("product.isContractItem")}
  </ProductTrait>
);

export const PredefinedTraits = {
  PreferredProduct,
  ContractProduct,
};
